var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.356 16C3.356 9.017 9.017 3.356 16 3.356c6.983 0 12.643 5.661 12.643 12.644 0 6.983-5.66 12.643-12.643 12.643S3.356 22.983 3.356 16zM16 1C7.716 1 1 7.716 1 16s6.716 15 15 15 15-6.716 15-15S24.284 1 16 1zm2.41 19.532c.046.174.103.328.17.463h2.84v-.172a3.698 3.698 0 0 1-.323-.986c-.073-.383-.11-.866-.11-1.45v-4.671c0-.631-.118-1.185-.353-1.662a3.277 3.277 0 0 0-.976-1.198 4.402 4.402 0 0 0-1.48-.715 6.647 6.647 0 0 0-1.833-.24c-.731 0-1.382.094-1.953.282a4.493 4.493 0 0 0-1.44.745c-.389.315-.688.68-.896 1.097a2.99 2.99 0 0 0-.302 1.32h2.8c0-.41.13-.736.392-.978.262-.248.678-.372 1.248-.372.645 0 1.138.154 1.48.463.343.302.514.715.514 1.238v.645h-1.56c-1.699 0-2.978.315-3.837.946-.851.624-1.277 1.51-1.277 2.658 0 .47.094.906.282 1.31.187.395.45.737.785 1.026.335.288.735.513 1.198.674.47.161.983.242 1.54.242.343 0 .661-.033.957-.1.295-.06.564-.145.805-.252.249-.114.473-.245.675-.393a3.67 3.67 0 0 0 .533-.472c.034.194.074.38.121.554zm-1.712-1.601c-.242.068-.504.101-.786.101-.537.001-.94-.123-1.208-.371a1.236 1.236 0 0 1-.392-.937c0-.249.046-.477.14-.685.095-.215.239-.396.433-.544.195-.154.447-.271.755-.352.31-.087.682-.13 1.118-.13h1.43v1.872c-.08.14-.192.282-.333.422a2.42 2.42 0 0 1-.503.363 3.026 3.026 0 0 1-.654.26z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.8889feab2b2223b7b0b562847d61591d.svg";
export { ForwardRef as ReactComponent };